<div class="sc-dialog-wrapper">
  @if (title) {
    <!-- <div class="m3-dialog-header">
      <mat-icon class="m3-dialog-icon">info</mat-icon>
      <h2 class="m3-dialog-headline" [innerHtml]="title"></h2>
    </div> -->
    <h2 mat-dialog-title [innerHtml]="title"></h2>
  }
  @if (body) {
    <div mat-dialog-content [innerHtml]="body"></div>
  }
  @if (actions && actions.length > 0) {
    <div mat-dialog-actions>
      @for (action of actions; track action) {
        <button
          mat-button
          [color]="action.color"
          (click)="handleActionClicked($event, action)"
        >
          {{ action.label | translate }}
        </button>
      }
    </div>
  }
</div>
